var exports = {
  "nM": "ComparisonRow.module__row___eXRuX2",
  "N4": "ComparisonRow.module__feature___eXRuX2",
  "oo": "ComparisonRow.module__featureText___eXRuX2",
  "a7": "ComparisonRow.module__valuesContainer___eXRuX2",
  "dY": "ComparisonRow.module__restrictedValue___eXRuX2",
  "ge": "ComparisonRow.module__stockValue___eXRuX2",
};

module.exports = exports;
